(function () {
  var brandTextPattern = /ZUPPERTOOLS|ZUPPERTOOL|Zuppertools|Zuppertool|zuppertools|zuppertool/g;

  function normalizeBrandText(value) {
    if (!value || !brandTextPattern.test(value)) return value;
    brandTextPattern.lastIndex = 0;
    return value.replace(brandTextPattern, function (match, offset, source) {
      var before = source.charAt(offset - 1);
      var after = source.charAt(offset + match.length);
      if (before === '@' || before === '/' || before === '.' || after === '@' || after === '/' || after === '.') {
        return match;
      }
      return 'ZUPPER';
    });
  }

  function normalizeVisibleBrandText(root) {
    var textWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || parent.closest('script, style, noscript, textarea, code, pre, [data-zs-brand-preserve]')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNodes = [];
    while (textWalker.nextNode()) textNodes.push(textWalker.currentNode);
    textNodes.forEach(function (node) {
      var normalized = normalizeBrandText(node.nodeValue);
      if (normalized !== node.nodeValue) node.nodeValue = normalized;
    });
    root.querySelectorAll('[title], [alt], [aria-label], [placeholder]').forEach(function (element) {
      ['title', 'alt', 'aria-label', 'placeholder'].forEach(function (attribute) {
        if (!element.hasAttribute(attribute)) return;
        var value = element.getAttribute(attribute);
        var normalized = normalizeBrandText(value);
        if (normalized !== value) element.setAttribute(attribute, normalized);
      });
    });
  }

  normalizeVisibleBrandText(document.body);

  document.addEventListener('change', function (event) {
    var languageSelect = event.target.closest('[data-zs-language-select]');
    if (languageSelect && languageSelect.form) languageSelect.form.submit();
  });

  function closestToggle(target) {
    return target.closest('[data-zs-toggle]');
  }

  function setExpanded(button, open) {
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeLightbox(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    resetLightboxZoom();
  }

  var lightboxZoom = 1;
  var lightboxPanX = 0;
  var lightboxPanY = 0;
  var lightboxDragging = false;
  var lightboxStartX = 0;
  var lightboxStartY = 0;
  var lightboxStartPanX = 0;
  var lightboxStartPanY = 0;

  function lightboxImage() {
    return document.querySelector('[data-zs-lightbox-image]');
  }

  function lightboxZoomLabel() {
    return document.querySelector('[data-zs-zoom-label]');
  }

  function applyLightboxZoom() {
    var image = lightboxImage();
    var label = lightboxZoomLabel();
    if (image) {
      image.style.setProperty('--zs-zoom', lightboxZoom);
      image.style.setProperty('--zs-pan-x', lightboxPanX + 'px');
      image.style.setProperty('--zs-pan-y', lightboxPanY + 'px');
    }
    if (label) {
      label.textContent = Math.round(lightboxZoom * 100) + '%';
    }
  }

  function setLightboxZoom(value) {
    lightboxZoom = Math.max(1, Math.min(3, value));
    if (lightboxZoom === 1) {
      lightboxPanX = 0;
      lightboxPanY = 0;
    }
    applyLightboxZoom();
  }

  function resetLightboxZoom() {
    lightboxZoom = 1;
    lightboxPanX = 0;
    lightboxPanY = 0;
    lightboxDragging = false;
    document.querySelectorAll('[data-zs-lightbox-stage]').forEach(function (stage) {
      stage.classList.remove('is-dragging');
    });
    applyLightboxZoom();
  }

  document.addEventListener('click', function (event) {
    var filterToggle = event.target.closest('[data-zs-filter-toggle], [data-zs-filter-close]');
    if (filterToggle) {
      var filterTarget = filterToggle.getAttribute('data-target');
      var filterPanel = filterTarget ? document.querySelector(filterTarget) : null;
      if (filterPanel) {
        var shouldOpen = filterToggle.hasAttribute('data-zs-filter-toggle') && !filterPanel.classList.contains('is-open');
        filterPanel.classList.toggle('is-open', shouldOpen);
        document.querySelectorAll('[data-zs-filter-toggle][data-target="' + filterTarget + '"]').forEach(function (button) {
          button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        });
      }
    }

    var toggle = closestToggle(event.target);
    if (toggle) {
      var targetSelector = toggle.getAttribute('data-zs-toggle');
      var panel = document.querySelector(targetSelector);
      if (panel) {
        var isOpen = panel.hasAttribute('hidden') === false;
        if (isOpen) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
        setExpanded(toggle, !isOpen);
      }
    }

    var galleryStep = event.target.closest('[data-zs-gallery-step]');
    if (galleryStep) {
      event.preventDefault();
      var stepGallery = galleryStep.closest('[data-zs-gallery]');
      if (stepGallery) {
        var thumbSelector = galleryStep.hasAttribute('data-zs-gallery-images-only')
          ? '[data-zs-thumb][data-media-kind="image"]'
          : '[data-zs-thumb]';
        var stepThumbs = Array.prototype.slice.call(stepGallery.querySelectorAll(thumbSelector));
        var activeThumb = stepGallery.querySelector('[data-zs-thumb].is-active');
        var activeIndex = stepThumbs.indexOf(activeThumb);
        var direction = parseInt(galleryStep.getAttribute('data-zs-gallery-step') || '1', 10);
        if (stepThumbs.length) {
          var nextIndex = activeIndex < 0 ? 0 : (activeIndex + direction + stepThumbs.length) % stepThumbs.length;
          stepThumbs[nextIndex].click();
        }
      }
      return;
    }

    var thumb = event.target.closest('[data-zt-thumb], [data-zs-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-zs-gallery]') || document;
      var image = gallery.querySelector('[data-zt-main-image], [data-zs-main-image]');
      var imageWrap = gallery.querySelector('[data-zs-main-image-wrap]');
      var videoWrap = gallery.querySelector('[data-zs-main-video-wrap]');
      var video = gallery.querySelector('[data-zs-main-video]');
      var lightboxImage = gallery.querySelector('[data-zs-lightbox-image]');
      var mediaKind = thumb.getAttribute('data-media-kind') || 'image';
      var src = thumb.getAttribute('data-src');
      var zoomSrc = thumb.getAttribute('data-zoom-src') || src;
      var alt = thumb.getAttribute('data-alt') || '';
      if (mediaKind === 'video' && video && videoWrap) {
        var videoSrc = thumb.getAttribute('data-video-src');
        var videoPoster = thumb.getAttribute('data-video-poster');
        if (videoPoster) video.poster = videoPoster;
        if (imageWrap) imageWrap.setAttribute('hidden', '');
        videoWrap.removeAttribute('hidden');
        if (videoSrc && video.getAttribute('src') !== videoSrc) {
          video.src = videoSrc;
          video.load();
        }
        video.removeAttribute('data-playback-error');
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {
            video.setAttribute('data-playback-error', 'true');
            video.controls = true;
          });
        }
      } else if (image && src) {
        if (video) video.pause();
        if (videoWrap) videoWrap.setAttribute('hidden', '');
        if (imageWrap) imageWrap.removeAttribute('hidden');
        image.src = src;
        image.setAttribute('data-zoom-src', zoomSrc);
        image.alt = alt;
        if (lightboxImage) {
          lightboxImage.src = zoomSrc;
          lightboxImage.alt = alt;
        }
      }
      gallery.querySelectorAll('[data-zt-thumb], [data-zs-thumb]').forEach(function (button) {
        button.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    }

    var lightboxOpen = event.target.closest('[data-zs-lightbox-open]');
    if (lightboxOpen) {
      var dialog = document.querySelector('[data-zs-lightbox]');
      var mainImage = document.querySelector('[data-zs-main-image]');
      var previewImage = document.querySelector('[data-zs-lightbox-image]');
      if (dialog && mainImage && previewImage) {
        previewImage.src = mainImage.getAttribute('data-zoom-src') || mainImage.src;
        previewImage.alt = mainImage.alt || '';
        resetLightboxZoom();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }
    }

    var lightboxClose = event.target.closest('[data-zs-lightbox-close]');
    if (lightboxClose) {
      closeLightbox(lightboxClose.closest('[data-zs-lightbox]'));
    }

    if (event.target.matches && event.target.matches('[data-zs-lightbox]')) {
      closeLightbox(event.target);
    }

    var richtextToggle = event.target.closest('[data-zs-richtext-toggle]');
    if (richtextToggle) {
      var richtext = richtextToggle.previousElementSibling;
      if (richtext && richtext.matches('[data-zs-richtext]')) {
        var expanded = richtext.classList.toggle('is-expanded');
        richtextToggle.textContent = expanded ? 'See less' : 'See more';
        richtextToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    var featuresToggle = event.target.closest('[data-zs-features-toggle]');
    if (featuresToggle) {
      var featureList = featuresToggle.previousElementSibling;
      if (featureList && featureList.matches('[data-zs-mobile-features]')) {
        var featuresExpanded = featureList.classList.toggle('is-expanded');
        featuresToggle.textContent = featuresExpanded ? featuresToggle.getAttribute('data-expanded-label') : featuresToggle.getAttribute('data-collapsed-label');
        featuresToggle.setAttribute('aria-expanded', featuresExpanded ? 'true' : 'false');
      }
    }

    var specificationsToggle = event.target.closest('[data-zs-specifications-toggle]');
    if (specificationsToggle) {
      var specificationsSection = specificationsToggle.closest('[data-zs-mobile-specifications]');
      if (specificationsSection) {
        var specificationsPreview = specificationsSection.querySelector('[data-zs-specifications-preview]');
        var specificationsFull = specificationsSection.querySelector('[data-zs-specifications-full]');
        var specificationsExpanded = specificationsToggle.getAttribute('aria-expanded') !== 'true';
        specificationsToggle.setAttribute('aria-expanded', specificationsExpanded ? 'true' : 'false');
        specificationsToggle.textContent = specificationsExpanded ? specificationsToggle.getAttribute('data-expanded-label') : specificationsToggle.getAttribute('data-collapsed-label');
        specificationsSection.classList.toggle('is-expanded', specificationsExpanded);
        if (specificationsPreview) specificationsPreview.hidden = specificationsExpanded;
        if (specificationsFull) specificationsFull.hidden = !specificationsExpanded;
      }
    }

    var zoomButton = event.target.closest('[data-zs-zoom]');
    if (zoomButton) {
      event.preventDefault();
      var mode = zoomButton.getAttribute('data-zs-zoom');
      if (mode === 'in') setLightboxZoom(lightboxZoom + 0.25);
      if (mode === 'out') setLightboxZoom(lightboxZoom - 0.25);
    }

    var qtyButton = event.target.closest('[data-zt-qty], [data-zs-qty]');
    if (qtyButton) {
      var input = document.querySelector(qtyButton.getAttribute('data-target'));
      if (!input) return;
      var value = parseInt(input.value || '1', 10);
      var mode = qtyButton.getAttribute('data-zt-qty') || qtyButton.getAttribute('data-zs-qty');
      if (mode === 'minus') value -= 1;
      if (mode === 'plus') value += 1;
      var nextValue = Math.max(1, value);
      var cartStepper = qtyButton.closest('[data-zs-cart-stepper]');
      if (cartStepper) {
        event.preventDefault();
        if (parseInt(input.value || '1', 10) === nextValue) return;
        updateCartLine(cartStepper, input, nextValue);
        return;
      }
      input.value = nextValue;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeLightbox(document.querySelector('[data-zs-lightbox]'));
    document.querySelectorAll('[data-zs-dismissable]:not([hidden])').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-zs-toggle][aria-expanded="true"]').forEach(function (button) {
      setExpanded(button, false);
    });
  });

  document.addEventListener('pointerdown', function (event) {
    var galleryStage = event.target.closest('[data-zs-gallery] [data-zs-main-image-wrap], [data-zs-gallery] [data-zs-main-video-wrap]');
    if (galleryStage && window.matchMedia('(max-width: 749px)').matches) {
      galleryStage.dataset.zsSwipeStartX = String(event.clientX);
      galleryStage.dataset.zsSwipeStartY = String(event.clientY);
    }

    var stage = event.target.closest('[data-zs-lightbox-stage]');
    if (!stage || lightboxZoom <= 1) return;
    lightboxDragging = true;
    lightboxStartX = event.clientX;
    lightboxStartY = event.clientY;
    lightboxStartPanX = lightboxPanX;
    lightboxStartPanY = lightboxPanY;
    stage.classList.add('is-dragging');
    if (stage.setPointerCapture && event.pointerId !== undefined) {
      stage.setPointerCapture(event.pointerId);
    }
  });

  document.addEventListener('pointermove', function (event) {
    var hoverButton = event.target.closest('[data-zs-main-image-wrap]');
    if (hoverButton && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var hoverImage = hoverButton.querySelector('[data-zs-main-image]');
      var hoverBounds = hoverButton.getBoundingClientRect();
      if (hoverImage && hoverBounds.width > 0 && hoverBounds.height > 0) {
        hoverImage.style.setProperty('--zs-hover-x', ((event.clientX - hoverBounds.left) / hoverBounds.width * 100) + '%');
        hoverImage.style.setProperty('--zs-hover-y', ((event.clientY - hoverBounds.top) / hoverBounds.height * 100) + '%');
        hoverImage.classList.add('is-hover-zoom');
      }
    }
    if (!lightboxDragging) return;
    lightboxPanX = lightboxStartPanX + event.clientX - lightboxStartX;
    lightboxPanY = lightboxStartPanY + event.clientY - lightboxStartY;
    applyLightboxZoom();
  });

  document.addEventListener('pointerup', function (event) {
    var galleryStage = event.target.closest('[data-zs-gallery] [data-zs-main-image-wrap], [data-zs-gallery] [data-zs-main-video-wrap]');
    if (galleryStage && galleryStage.dataset.zsSwipeStartX) {
      var deltaX = event.clientX - parseFloat(galleryStage.dataset.zsSwipeStartX);
      var deltaY = event.clientY - parseFloat(galleryStage.dataset.zsSwipeStartY || '0');
      delete galleryStage.dataset.zsSwipeStartX;
      delete galleryStage.dataset.zsSwipeStartY;
      if (Math.abs(deltaX) >= 42 && Math.abs(deltaX) > Math.abs(deltaY)) {
        var galleryRoot = galleryStage.closest('[data-zs-gallery]');
        var swipeButton = galleryRoot && galleryRoot.querySelector('[data-zs-gallery-step="' + (deltaX < 0 ? '1' : '-1') + '"]');
        if (swipeButton) swipeButton.click();
      }
    }

    if (!lightboxDragging) return;
    lightboxDragging = false;
    document.querySelectorAll('[data-zs-lightbox-stage]').forEach(function (stage) {
      stage.classList.remove('is-dragging');
    });
  });

  document.addEventListener('pointerout', function (event) {
    var hoverButton = event.target.closest('[data-zs-main-image-wrap]');
    if (!hoverButton || hoverButton.contains(event.relatedTarget)) return;
    var hoverImage = hoverButton.querySelector('[data-zs-main-image]');
    if (hoverImage) hoverImage.classList.remove('is-hover-zoom');
  });

  function setStepperLoading(stepper, loading) {
    stepper.classList.toggle('is-loading', loading);
    stepper.querySelectorAll('button, input').forEach(function (control) {
      control.disabled = loading;
    });
  }

  function updateCartLine(stepper, input, quantity) {
    var key = stepper.getAttribute('data-line-key');
    var line = parseInt(stepper.getAttribute('data-line-index') || '0', 10);
    var payload = { quantity: quantity };
    if (key) {
      payload.id = key;
    } else if (line > 0) {
      payload.line = line;
    } else {
      input.value = quantity;
      return;
    }

    setStepperLoading(stepper, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function () {
        input.value = quantity;
        window.location.reload();
      })
      .catch(function () {
        setStepperLoading(stepper, false);
      });
  }

  function loadStorefrontHeroVideo(video) {
    if (!video || video.getAttribute('data-zs-video-loaded') === 'true') return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection && connection.saveData) return;

    var source = video.querySelector('source[data-src]');
    if (!source) return;

    source.src = source.getAttribute('data-src');
    video.setAttribute('data-zs-video-loaded', 'true');
    video.addEventListener('canplay', function () {
      video.classList.add('is-ready');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }, { once: true });
    video.load();
  }

  function initStorefrontHeroVideo() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll('[data-zs-hero-video]').forEach(function (video) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadStorefrontHeroVideo(video);
            observer.disconnect();
          });
        }, { rootMargin: '160px 0px' });
        observer.observe(video);
      } else {
        loadStorefrontHeroVideo(video);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStorefrontHeroVideo, { once: true });
  } else {
    initStorefrontHeroVideo();
  }

  var storefrontDesktopMedia = window.matchMedia('(min-width: 750px)');
  if (typeof storefrontDesktopMedia.addEventListener === 'function') {
    storefrontDesktopMedia.addEventListener('change', function (event) {
      if (event.matches) initStorefrontHeroVideo();
    });
  }

  function formatStorefrontMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function updateFbtTotal(container) {
    var totalNode = container.querySelector('[data-zs-fbt-total]');
    if (!totalNode) return;
    var total = parseInt(totalNode.getAttribute('data-base-price') || '0', 10);
    container.querySelectorAll('[data-zs-fbt-item]:checked').forEach(function (input) {
      total += parseInt(input.getAttribute('data-price') || '0', 10);
    });
    totalNode.textContent = formatStorefrontMoney(total);
  }

  function initPdpCommerce() {
    document.querySelectorAll('[data-zs-features-toggle]').forEach(function (button) {
      var featureList = button.previousElementSibling;
      if (!featureList || featureList.querySelectorAll('li').length <= 2) {
        button.hidden = true;
      }
    });

    document.querySelectorAll('[data-zs-fbt]').forEach(function (container) {
      updateFbtTotal(container);
      container.querySelectorAll('[data-zs-fbt-item]').forEach(function (input) {
        input.addEventListener('change', function () { updateFbtTotal(container); });
      });
      var addButton = container.querySelector('[data-zs-fbt-add]');
      if (!addButton) return;
      addButton.addEventListener('click', function () {
        var items = [{ id: parseInt(container.getAttribute('data-current-variant-id'), 10), quantity: 1 }];
        container.querySelectorAll('[data-zs-fbt-item]:checked').forEach(function (input) {
          items.push({ id: parseInt(input.getAttribute('data-variant-id'), 10), quantity: 1 });
        });
        var status = container.querySelector('[data-zs-fbt-status]');
        var addUrl = container.getAttribute('data-cart-add-url') || ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js');
        addButton.disabled = true;
        if (status) status.textContent = 'Adding products...';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to add products');
            return response.json();
          })
          .then(function () {
            if (status) status.textContent = 'Added to cart.';
            window.location.href = container.getAttribute('data-cart-url') || '/cart';
          })
          .catch(function () {
            addButton.disabled = false;
            if (status) status.textContent = 'Unable to add this group. Add each item separately.';
          });
      });
    });

    document.querySelectorAll('[data-zs-pdp-tabs]').forEach(function (tabs) {
      if (tabs.closest('[data-zs-pdp-page]')) return;
      var links = Array.prototype.slice.call(tabs.querySelectorAll('a[href^="#"]'));
      var sections = links.map(function (link) { return document.querySelector(link.getAttribute('href')); }).filter(Boolean);
      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          links.forEach(function (item) { item.classList.toggle('is-active', item === link); });
        });
      });
      if ('IntersectionObserver' in window && sections.length) {
        var sectionObserver = new IntersectionObserver(function (entries) {
          var visible = entries.filter(function (entry) { return entry.isIntersecting; }).sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; })[0];
          if (!visible) return;
          links.forEach(function (link) { link.classList.toggle('is-active', link.getAttribute('href') === '#' + visible.target.id); });
        }, { rootMargin: '-90px 0px -65% 0px', threshold: 0 });
        sections.forEach(function (section) { sectionObserver.observe(section); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpCommerce, { once: true });
  } else {
    initPdpCommerce();
  }
})();
